export const FaqContent = () => {
  return {
    faqContent: [
      {
        id: 1,
        title: 'What is this product about?',
        content:
          'This product provides benefits on the occurrence of specific events to the insured person that may arise during domestic or international travel, for business or leisure. Benefits including death or permanent disability due to accident, medical expenses arising due to accident or illness, various inconvenience, losses or damages to baggage and/or personal effects, personal liability, emergency services and optional cover on adventurous activities.',
      },
      {
        id: 2,
        title:
          'I am a Non-Filipino (foreigner). Am I entitled to buy Travel 360 travel insurance?',
        content:
          'Yes, with the condition that all departures is from Philippines and you are returning to Philippines after your trip.',
      },
      {
        id: 3,
        title:
          'I am a Filipino but I am departing from another country (Singapore, Indonesia, Thailand etc). Can I buy this travel insurance?',
        content:
          "No, you can't. Your origin country of departure must be from Philippines.",
      },
      {
        id: 4,
        title: 'How do I buy for my travel insurance?',
        content:
          'You can buy your travel insurance in any of the following methods: <ol style="list-style: none; padding-left: 0;"><li>a) Buy online on our website; or</li><li>b) Locate and contact an agent to buy; or</li><li>c) Visit our nearest branch in your area.</li></ol> You can purchase your insurance 3 hours on the same day before departure. You are encouraged to buy within 30 days before departure in order to enjoy the trip cancellation benefit.',
      },
      {
        id: 5,
        title:
          'Can I purchase Travel 360 for my family and how much premium do I have to pay?',
        content:
          '<p>Yes, you may purchase Travel 360 for your family, i.e. spouse and children who are travelling together with you.</p>The premium varies depending on your choice of plan, destination and duration of cover selected.',
      },
    ],
  };
};

export default FaqContent;
